import ApiUrl from '../services/APIUrl';
import type { Dispatch } from '@reduxjs/toolkit';
import { handleSuccess } from '../services/DataHelperFunctions';
import { appSettings } from '../settings';
import AxiosClient from './AxiosClient';
import { handleError, successHandle } from '../services/ErrorHandle';
import { EUrlParams, EViews } from '../data/Constants';

import type { IProductType, ISaveView, IProductCode } from '../../types';
import type { IApiError } from '../../types/IApiTypes';
import { IPagination } from '../../types/IRequestTypes';

export const CategoryApi = {
  //This method returns the List Of Values
  getViewDetails: (payload: IProductCode, dispatch?: Dispatch) => {
    const params: Record<string, string | null> = { view: EViews.Master };

    if (payload?.productCode) {
      params[EUrlParams.ProductId] = `${payload.productCode}`;
    }

    return AxiosClient.get(ApiUrl.ReadView, {
      params,
      baseURL: appSettings.DisEndpoint,
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        return handleError(error, undefined, dispatch);
      });
  },

  getFeatureFamilies: (payload: IProductType, dispatch?: Dispatch) => {
    return AxiosClient.post(ApiUrl.ReadFamilyFeature, {
      workItemId: payload.workItemNum,
      code: '',
      includeScopeFeatures: payload.includeScopeFeatures,
      productCode: payload.productCode,
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        return handleError(error, undefined, dispatch);
      });
  },

  getCategories: (action: IPagination, dispatch?: Dispatch) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    return AxiosClient.post(
      `${ApiUrl.ReadCategories}?${queryParams}`,
      {},
      {
        baseURL: appSettings.DisEndpoint,
      }
    )
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((error: IApiError) => {
        return handleError(error, undefined, dispatch);
      });
  },

  saveView: (payload: ISaveView, dispatch?: Dispatch) => {
    return AxiosClient.post(ApiUrl.SaveView, payload, {
      baseURL: appSettings.DisEndpoint,
    })
      .then((response) => {
        successHandle(response, dispatch);
        return payload;
      })
      .catch((error: IApiError) => {
        return handleError(error, undefined, dispatch);
      });
  },

  getMultiNumericFeatures: (payload: { searchKey: string | null }, skipLoader: boolean = false) => {
    const isActive = true;
    return AxiosClient.post(
      ApiUrl.ReadMultiNumericFeature,
      {
        active: isActive,
      },
      {
        params: { [EUrlParams.Search]: `${payload.searchKey}` },
        headers: { skipLoader: skipLoader },
      }
    )
      .then((response) => {
        return response;
      })
      .catch((error: IApiError) => {
        return { error };
      });
  },
};
